import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';
import { ComparisonBadge } from './ComparisonBadge';
import { Sparkline } from './Sparkline';
import { SkeletonKpi } from './states';

export const KpiCard = ({
  title,
  value,
  delta,
  deltaLabel,
  increaseIsBad,
  sparklineData,
  emptyLabel,
  tooltip,
  onClick,
  loading,
}) => {
  const { theme } = useTheme();
  if (loading) return <SkeletonKpi />;

  const isEmpty = value === null || value === undefined || value === '';

  const cardStyle = {
    background: theme.color.surface,
    border: `1px solid ${theme.color.border}`,
    borderRadius: theme.radius.md,
    padding: theme.space.lg,
    boxShadow: theme.shadow.sm,
    cursor: onClick ? 'pointer' : 'default',
    transition: 'transform 0.1s ease, box-shadow 0.1s ease',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.space.sm,
    minHeight: 120,
    textAlign: 'left',
    width: '100%',
    fontFamily: theme.font.family,
  };

  const inner = (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{
          fontSize: theme.font.size.xs,
          fontWeight: theme.font.weight.semibold,
          color: theme.color.textSoft,
          textTransform: 'uppercase',
          letterSpacing: 0.6,
        }}>{title}</span>
        {tooltip && (
          <span title={tooltip} style={{ color: theme.color.muted, cursor: 'help', fontSize: theme.font.size.xs }}>ⓘ</span>
        )}
      </div>
      {isEmpty ? (
        <div style={{
          fontSize: theme.font.size.sm,
          color: theme.color.muted,
          background: theme.color.surfaceAlt,
          padding: `${theme.space.sm}px ${theme.space.md}px`,
          borderRadius: theme.radius.sm,
          display: 'inline-block',
          alignSelf: 'flex-start',
        }}>
          {emptyLabel || 'Veri yok'}
        </div>
      ) : (
        <div style={{
          fontSize: theme.font.size.xxl,
          fontWeight: theme.font.weight.bold,
          color: theme.color.text,
          lineHeight: 1.1,
        }}>{value}</div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: 'auto' }}>
        {delta !== undefined && (
          <ComparisonBadge delta={delta} label={deltaLabel} increaseIsBad={increaseIsBad} />
        )}
        {sparklineData && sparklineData.length > 0 && (
          <Sparkline data={sparklineData} color={theme.color.accent} />
        )}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = theme.shadow.md; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = theme.shadow.sm; }}
        style={cardStyle}>
        {inner}
      </button>
    );
  }
  return <div style={cardStyle}>{inner}</div>;
};
